import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { AppointDetailAction, DeleteAppointAction, UpdateAppointAction, DeleteActionHistoryItem } from '../../redux/actions/AppointActions'

import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Loader from '../layout/Loader';
import Badge from '../layout/Badge';
import { Link } from 'react-router-dom';

const Edit = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()

    const userLogin = useSelector(state => state.userSignIn)
    const { error, userInfo } = userLogin
    //getting the details
    const detail = useSelector(state => state.appointDetail)
    const { loading, appoint, success: detailSuccess } = detail

    const updateAppoint = useSelector((state) => state.appointUpdate)
    const { loading: updateLoading, success: updateSuccess } = updateAppoint

    const deleteAppoint = useSelector((state) => state.appointDelete)
    const { loading: deleting, success: deleteSuccess } = deleteAppoint

    const deleteActionHistory = useSelector((state) => state.appointActionHistoryDelete)
    const { loading: deletingHistory, success: deleteHistorySuccess } = deleteActionHistory

    const [name, setName] = useState()
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [des, setDes] = useState('');
    const [timing, setTiming] = useState(null); // Initialize with null
    const [action, setAction] = useState('');
    const [actionStatus, setActionStatus] = useState(false);
    const [payment, setPayment] = useState(0.00)
    const [paymentStatus, setPaymentStatus] = useState(false);
    const [completion, setCompletion] = useState(false);

    // Validation states
    const [nameError, setNameError] = useState('')
    const [actionError, setActionError] = useState('')

    const handleSubmit = (event) => {
        event.preventDefault();

        // Reset errors
        setNameError('')
        setActionError('')
        
        // Validate required fields
        let isValid = true;
        if (!name || !name.trim()) {
            setNameError('This field is required')
            isValid = false
        }
        if (!action) {
            setActionError('This field is required')
            isValid = false
        }
        
        if (!isValid) {
            return;
        }

       
        const timingString = timing ? timing.toISOString() : '';

        dispatch(UpdateAppointAction({
            id: appoint._id,
            name,
            email,
            phone,
            address,
            des,
            timing: timingString, 
            action,
            actionStatus,
            payment,
            paymentStatus,
            completion
        }, userInfo.token))
        // if (updateSuccess) {
        //     navigate('/appointments')
        // }
    }

    const handleDelete = (event) => {
        event.preventDefault();
        dispatch(DeleteAppointAction(id, userInfo.token))
        // if (deleteSuccess) {
        //     navigate('/')
        // }
    }

    // Handle deletion of action history item
    const handleDeleteActionHistory = (historyIndex) => {
        // Directly delete without confirmation
        dispatch(DeleteActionHistoryItem(id, historyIndex, userInfo.token))
    }

    useEffect(() => {
        if (!userInfo) {
            navigate('/sign-in')
        }
        window.scrollTo(0, 0)
    }, [userInfo, navigate])

    useEffect(() => {
        dispatch({ type: 'APPOINT_UPDATE_RESET' })
        if (id) {
            dispatch(AppointDetailAction(id, userInfo.token));
        }
    }, [dispatch, id, userInfo.token]);

    useEffect(() => {
        if (detailSuccess && appoint) {
            setName(appoint.name)
            setEmail(appoint.email)
            setPhone(appoint.phone)
            setAddress(appoint.address)
            setDes(appoint.des)
            setTiming(dayjs(appoint.timing)) 
            setAction(appoint.action)
            setActionStatus(appoint.actionStatus)
            setPayment(appoint.payment)
            setPaymentStatus(appoint.paymentStatus)
            setCompletion(appoint.completion)
        }
    }, [detailSuccess, appoint]);

    // Effect to clear errors when fields change
    useEffect(() => {
        if (name && name.trim()) {
            setNameError('')
        }
        if (action) {
            setActionError('')
        }
    }, [name, action]);

    // Format date and time for display
    const formatDateTime = (dateString) => {
        const options = { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        return new Date(dateString).toLocaleString(undefined, options);
    };

    // Render action history items
    const renderActionHistory = () => {
        if (!appoint.actionHistory || appoint.actionHistory.length === 0) {
            return <p>No action history available.</p>;
        }

        return appoint.actionHistory.map((historyItem, index) => {
            let message = '';
            if (historyItem.type === 'created') {
                message = `The action has been added with ${historyItem.action} on ${formatDateTime(historyItem.timestamp)}`;
            } else if (historyItem.type === 'updated') {
                message = `The action has been updated from ${historyItem.previousAction} to ${historyItem.action} on ${formatDateTime(historyItem.timestamp)}`;
            }
            
            return (
                <div key={index} className="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded">
                    <span>{message}</span>
                    {historyItem.type === 'updated' && (
                        <button 
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeleteActionHistory(index)}
                            disabled={deletingHistory}
                        >
                            {deletingHistory ? 'Deleting...' : 'Delete'}
                        </button>
                    )}
                </div>
            );
        });
    };

   
    return (
        <>
            {updateSuccess || deleteSuccess || deleteHistorySuccess ? (
                <Badge p={{ type: 'success', message: 'Action completed successfully👍' }} />
            ) : (loading || updateLoading || deleting || deletingHistory ? (<Loader />) : (
                detailSuccess &&
                <>
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Dashboard</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/appointments">
                                            <i className="bx bx-calendar-event" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Edit Appointment
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="ms-auto">
                            <div className="btn-group">
                                <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown">
                                    Settings
                                </button>
                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                    {" "}
                                    <button type="button"
                                        className="btn btn-danger px-5"
                                        onClick={handleDelete}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <form onSubmit={handleSubmit}>
                            <div className="col-lg-12 mx-auto">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-12 col-lg-8">
                                                <div className="card shadow-none bg-light border">
                                                    <div className="card-body">
                                                        <div className="row g-3">
                                                            <div className="col-6">
                                                                <label className="form-label"> Name</label>
                                                                <input
                                                                    type="text"
                                                                    className={`form-control ${nameError ? 'is-invalid' : ''}`}
                                                                    placeholder="Client Name"
                                                                    value={name || ''} onChange={(e) => setName(e.target.value)}
                                                                />
                                                                {nameError && <div className="invalid-feedback">{nameError}</div>}
                                                            </div>
                                                            <div className="col-6">
                                                                <label className="form-label"> email</label>
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="Client email"
                                                                    value={email} onChange={(e) => setEmail(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-4">
                                                                <label className="form-label">Phone</label>
                                                                <input
                                                                    type="telephone"
                                                                    className="form-control"
                                                                    placeholder="Client Phone"
                                                                    value={phone} onChange={(e) => setPhone(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-8">
                                                                <label className="form-label">Address</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Client address"
                                                                    value={address} onChange={(e) => setAddress(e.target.value)}
                                                                />
                                                            </div>

                                                            <div className="col-12">
                                                                <label className="form-label">Full description</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder="Full description"
                                                                    rows={6}
                                                                    cols={4}
                                                                    defaultValue={""}
                                                                    value={des} onChange={(e) => setDes(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-4">
                                                <div className="card shadow-none bg-light border">
                                                    <div className="card-body">
                                                        <div className="row g-3">
                                                            <div className="col-12">
                                                                <div className="bg-secondary p-2">
                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <DateTimePicker
                                                                            renderInput={(props) => <TextField {...props} />}
                                                                            label="DateTimePicker"
                                                                            value={timing}
                                                                            onChange={(newValue) => {
                                                                                setTiming(newValue);
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label">Action</label>
                                                                <select className={`form-select ${actionError ? 'is-invalid' : ''}`}
                                                                    value={action} onChange={(e) => setAction(e.target.value)}>
                                                                    <option value={action}>{action}</option>
                                                                    {
                                                                        (() => {
                                                                            switch (action) {
                                                                                case 'General-Inquiry':
                                                                                    return (
                                                                                        <>
                                                                                            <option value='Quotation'>Quotation</option>
                                                                                            <option value='Measurement'>Measurement</option>
                                                                                            <option value='Production'>Production</option>
                                                                                            <option value='Installation'>Installation</option>
                                                                                            <option value='Repair/Inspection'>Repair/Inspection</option>
                                                                                            <option value=''>--Reset--</option>
                                                                                        </>
                                                                                    )
                                                                                case 'Quotation':
                                                                                    return (
                                                                                        <>
                                                                                            <option value='Measurement'>Measurement</option>
                                                                                            <option value='Production'>Production</option>
                                                                                            <option value='Installation'>Installation</option>
                                                                                            <option value='Repair/Inspection'>Repair/Inspection</option>
                                                                                            <option value=''>--Reset--</option>
                                                                                        </>
                                                                                    )
                                                                                case 'Measurement':
                                                                                    return (
                                                                                        <>
                                                                                            <option value='Quotation'>Quotation</option>
                                                                                            <option value='Production'>Production</option>
                                                                                            <option value='Installation'>Installation</option>
                                                                                            <option value=''>--Reset--</option>
                                                                                        </>
                                                                                    )
                                                                                case 'Production':
                                                                                    return (
                                                                                        <>
                                                                                            <option value='Installation'>Installation</option>
                                                                                            <option value=''>--Reset--</option>
                                                                                        </>
                                                                                    )
                                                                                case 'Installation':
                                                                                    return (
                                                                                        <>
                                                                                            <option value='Production'>Production</option>
                                                                                            <option value='Repair/Inspection'>Repair/Inspection</option>
                                                                                            <option value=''>--Reset--</option>
                                                                                        </>
                                                                                    )
                                                                                case 'Repair/Inspection':
                                                                                    return (
                                                                                        <>
                                                                                            <option value='Production'>Production</option>
                                                                                            <option value='Installation'>Installation</option>
                                                                                            <option value=''>--Reset--</option>
                                                                                        </>
                                                                                    )

                                                                                default:
                                                                                    return (
                                                                                        <>
                                                                                            <option value='General-Inquiry'>General Inquiry</option>
                                                                                            <option value='Quotation'>Quotation</option>
                                                                                            <option value='Measurement'>Measurement</option>
                                                                                            <option value='Production'>Production</option>
                                                                                            <option value='Installation'>Installation</option>
                                                                                            <option value='Repair/Inspection'>Repair/Inspection</option>
                                                                                        </>
                                                                                    )
                                                                            }
                                                                        })()
                                                                    }
                                                                </select>
                                                                {actionError && <div className="invalid-feedback">{actionError}</div>}
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label">Action Status</label>
                                                                <select className="form-select"
                                                                    value={actionStatus} onChange={(e) => setActionStatus(e.target.value)}>
                                                                    <option></option>
                                                                    <option value={false}>Pending</option>
                                                                    <option value={true}>Completed</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label">Payment</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Payment"
                                                                    pattern="^\d*(\.\d{0,2})?$"
                                                                    value={payment} onChange={(e) => setPayment(e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="col-12">
                                                                <label className="form-label">Payment Status</label>
                                                                <select className="form-select"
                                                                    value={paymentStatus} onChange={(e) => setPaymentStatus(e.target.value)}>
                                                                    <option></option>
                                                                    <option value={false}>Pending</option>
                                                                    <option value={true}>Paid</option>
                                                                </select>
                                                            </div>
                                                            {
                                                                action.status == true && (
                                                                    <div className="col-12">
                                                                        <label className="form-label">Project Status</label>
                                                                        <select className="form-select"
                                                                            value={completion} onChange={(e) => setCompletion(e.target.value)}>
                                                                            <option></option>
                                                                            <option value={false}> Project Pending</option>
                                                                            <option value={true}>Project Completed</option>
                                                                        </select>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                        {/*end row*/}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Action History Section */}
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="card border">
                                                    <div className="card-header">
                                                        <h5 className="mb-0">Action History</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="bg-light p-3 rounded">
                                                            {renderActionHistory()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*end row*/}
                                    </div>
                                    <div className="card-header py-3 bg-transparent">
                                        <div className="d-sm-flex align-items-center">
                                            <h5 className="mb-2 mb-sm-0">Edit Project</h5>
                                            <div className="ms-auto ">
                                                <button type="submit"
                                                    className="btn btn-primary"
                                                    onSubmit={handleSubmit}
                                                >
                                                    Update Project
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </>
            ))}
        </>
    )
}

export default Edit